const BASE_API = {
    cao: {
        base: 'http://192.168.2.196:8087',
        web: 'http://192.168.2.196:8085',
        admin: 'http://192.168.2.196:8088'
    },
    local: {
        base: 'http://192.168.2.205:8087',
        web: 'http://192.168.2.205:8085',
        admin: 'http://192.168.2.205:8088'
    },
    wu: {
        base: 'http://192.168.2.99:8087',
        web: 'http://192.168.2.99:8085',
        admin: 'http://192.168.2.99:8088'
    },
    wang: {
        base: 'http://47.75.108.138:8187',
        web: 'http://192.168.2.112:8085',
        admin: 'http://192.168.2.112:8088'
    },
    jin: {
        base: 'https://pay.egc56.com/base',
        web: 'https://pay.egc56.com/web',
        admin: 'https://bill.egc56.com'
    },
    // test: {
    //     base: 'http://47.75.108.138:8187',
    //     web: 'http://47.75.108.138:8185',
    //     admin: 'http://47.75.108.138:8188'
    // },
    test: {
        base: 'http://120.78.209.38:8087',
        web: 'http://120.78.209.38:8085',
        admin: 'http://120.78.209.38:8088'
    },
    rel: {
        base: 'http://apirel.a5bpay.com/base',
        web: 'http://apirel.a5bpay.com/web',
        admin: 'http://reladmin.a5bpay.com'
    },
    prod: {
        base: 'https://pay.egc56.com/base',
        web: 'https://pay.egc56.com/web',
        admin: 'https://bill.egc56.com'
    },
    yangWu: {
        base: 'http://192.168.0.18:8087',
        web: 'http://192.168.0.18:8085',
        admin: 'http://192.168.0.18:8088'
    }
}

let api = BASE_API.prod

if (process.env.NODE_ENV == 'production') {
    if (window.location.host == 'pay.egc56.com') {
        api = BASE_API.prod
    } else if(window.location.host == 'rel.a5bpay.com') {
        api = BASE_API.rel
    } else {
        api = BASE_API.test
    }
}

export default api
